/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import { WHISPER_ACTIVE_TIME } from '../../config';
import { RootState, useTivoDispatch, useTivoSelector } from '../../core/tivo/tivo-redux-wrapper';
import { hideWhisperAction } from '../../store/whisper/whisper.actions';
import { hideWhisper } from '../../store/whisper/whisper.reducer';
import { WhisperProps } from './WhisperProps';

import './Whisper.scss';

const Whisper: FunctionComponent<WhisperProps> = (props): JSX.Element => {
    const { message, iconType } = props;

    const {
        isWhisperActive,
        iconType: stateIconType,
        message: stateMessage,
    } = useTivoSelector((state: RootState) => state.whisper);
    const dispatch = useTivoDispatch();

    const [isActive, setIsActive] = useState(false);
    const [whisperHeight, setWhisperHeight] = useState<number | undefined>(undefined);

    const whisperRef = useRef<HTMLDivElement>(null);
    const messageToDisplay = stateMessage !== undefined ? stateMessage : message;

    useEffect(() => {
        let timeoutId;

        if (isWhisperActive) {
            setIsActive(true);
            timeoutId = setTimeout(() => {
                setIsActive(false);
                setWhisperHeight(undefined);
                dispatch(hideWhisperAction());
            }, WHISPER_ACTIVE_TIME);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [isWhisperActive]);

    useEffect(() => {
        if (isActive) {
            setWhisperHeight(whisperRef.current?.clientHeight);
        }
        return () => {
            setWhisperHeight(undefined);
        };
    }, [isActive, messageToDisplay]);

    useEffect(() => {
        return () => {
            dispatch(hideWhisper());
        };
    }, []);

    const iconClass = stateIconType !== undefined ? stateIconType : iconType;

    return (
        <div className={`whisper-container ${!isActive ? 'hidden' : ''}`}>
            <div
                ref={whisperRef}
                className={`whisper ${isWhisperActive ? 'show-whisper' : 'hide-whisper'}`}
                style={{ height: whisperHeight }}
            >
                <div className={`icon-section${iconClass ? ` ${iconClass}` : ''}`}></div>
                <div className="seperator-image"></div>
                <div className="message">{messageToDisplay}</div>
            </div>
        </div>
    );
};

export default Whisper;
